import type { DeploymentStepState } from '../../../../mock-data/types';

/** The visual state a bounce card renders. Mirrors DeploymentStepState plus the
 *  synthetic terminal `confirm` card and the leading-edge `in-progress`. `pending`
 *  steps have not run yet — shown when the window slides forward of the live edge. */
export type CardStatus = 'pending' | 'in-progress' | 'completed' | 'failed' | 'skipped' | 'confirm';

/** Stable id for the synthetic confirmation card appended after the last step. */
export const CONFIRM_ID = '__confirm__';

/**
 * One immutable entry in the replayed deploy timeline. Built once from the
 * deployment steps. `id` is a MONOTONIC counter (c0, c1, …), never `${i}-${label}`:
 * the mock has duplicate labels, and a colliding key would corrupt the enter/exit
 * diff + the GSAP ref map.
 */
export type TimelineEntry = {
  id: string;
  label: string;
  /** Visual state once the entry has settled (completed/failed/skipped). */
  settledState: Exclude<CardStatus, 'in-progress' | 'confirm'> | 'confirm';
  /** How long this entry dwells "in progress" during the mock replay (ms). */
  durationMs: number;
  /** 1-based position of this step in the deploy ("STEP {n} OF {total}"). */
  stepNumber: number;
  /** Total real steps in the deploy (excludes the confirmation card). */
  stepTotal: number;
  /** Optional short completion timestamp from the source data ("08:41"). */
  at?: string;
};

export type { DeploymentStepState };
